/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_How_TitleInputs */

const da_forside_how_title = /** @type {(inputs: Forside_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan virker det`)
};

/** @type {(inputs: Forside_How_TitleInputs) => LocalizedString} */
const en_forside_how_title = da_forside_how_title;

/**

* @param {Forside_How_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_how_title = /** @type {((inputs?: Forside_How_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_How_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_how_title(inputs)
	return /** @type {LocalizedString} */ ("Sådan virker det")
});